import { makeStyles } from "@mui/styles";

export const useStylesLogin = makeStyles(theme => ({
  paper: { marginTop: theme.spacing(8), display: 'flex', flexDirection: 'column', alignItems: 'center', },
  avatar: { margin: theme.spacing(1), width: 200, /*height: 90,*/ },
  form: { width: '100%', /* Fix IE 11 issue.*/ marginTop: theme.spacing(1), },
  submit: { margin: theme.spacing(3, 0, 2), },
}));